import { Box, Typography } from "@mui/material";
import IFrameModal from "../IFrameModal";
import { useState } from "react";

interface InstallationGuideProps {
  url: string;
}

export const InstallationGuide = (props: InstallationGuideProps) => {
  const { url } = props;
  const [confluenceModalContent, setConfluenceModalContent] =
    useState(url);
  const [confluenceModalIsOpen, setConfluenceModalIsOpen] = useState(false);
  const handleCloseConfluenceModal = () => {
    setConfluenceModalIsOpen(false);
    setConfluenceModalContent("");
  };

  return (
    <Box sx={{ ml: 4, mb: 1, mt: 0 ,cursor:"pointer"}}>
      <Typography variant="subtitle1" fontWeight={600} onClick={()=>setConfluenceModalIsOpen(true)}>
        (Installation and Setup Guides)
      </Typography>
      <IFrameModal
        modalContent={confluenceModalContent}
        handleCloseModal={handleCloseConfluenceModal}
        isModalOpen={confluenceModalIsOpen}
      />
    </Box>
  );
};
